const appReducer = (
  state = {
    online: false,
    notification: null,
    featureFlags: null,
    incidents: null,
    shouldListen: true
  },
  action
) => {
  switch (action.type) {
    case "SET_ONLINE":
      return {
        ...state,
        online: action.payload.online
      };

    case "SET_NOTIFICATION_PERMISSION":
      return {
        ...state,
        notification: action.payload.notification
      };

    case "SET_FEATURE_FLAGS":
      return {
        ...state,
        featureFlags: action.payload.featureFlags
      };

    case "PUT_SHOULD_LISTEN":
      return {
        ...state,
        shouldListen: action.payload.data
      };

    case "SET_INCIDENTS":
      return {
        ...state,
        incidents: action.payload.incidents
      };

    default:
      return state;
  }
};
export default appReducer;
